import React, { useEffect, useContext, useState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Color_Export from '../../Assets/Icons/Icon_Color_Export.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useReporting } from '../../Contexts/Context_Reporter';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';

export default function Subwindow_Modal_Report_Export({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Report_Type, Report_Output_Type, Report_Output_Scale, Report_Output_Scale_Set } = useReporting();
    const { Confirmer_Respond } = useStatus();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    const [FileName, FileName_Set] = useState("Document");
    const Confirm = async () => {
        const Passed = await UI.Input_Evaluate([
            {
                Type: "Text",
                ID: "File_Name",
                AC: ""
            }
        ]);
        if (Passed) {
            Confirmer_Respond(true, {
                FileName: FileName,
                FileScale: UI.Element_Value_Get("File_Scale") || 3
            }, true, "Window_Report_Export");
        }
    }

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_Report_Export");
    }


    return (
        <ui-subwindow Type='Modal' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Color_Export} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>
                <h2 className='General_Title' style={{textAlign: "center"}}>
                    Export {Report_Output_Type === "PDF" ?
                        "document as a PDF"
                        :
                        Report_Output_Type === "Image" ?
                            "document as image(s)"
                            :
                            ""
                    }
                </h2>
                <p className='General_Paragraph' style={{ textAlign: "center", marginTop: "5px", marginBottom: "10px" }}>
                    Please specify a file name for this document.
                </p>
                <div style={{ display: "grid", gridTemplateColumns: "auto 1fr auto auto", gap: "10px", alignItems: "center", marginBottom: "20px" }}>
                    <UI_Input_Text
                        Label_Text="File name:"
                        Required={true}
                        Value={FileName}
                        onChange={(e) => FileName_Set(e.target.value)}
                        id="File_Name"
                    />
                    <p className='General_Paragraph'>
                        {Report_Output_Type === "PDF" ?
                            ".pdf"
                            :
                            Report_Output_Type === "Image" ?
                                ".png"
                                :
                                ""
                        }
                    </p>
                </div>
                <UI_Input_Text
                    id="File_Scale"
                    Label_Text="Scale:"
                    Value={Report_Output_Scale}
                    Input_Type='number'
                    max={10}
                    min={0.5}
                    // onChange={(e) => Report_Output_Scale_Set(e.target.value)}
                />
                
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' State="Positive" onClick={Confirm}>
                    Export document
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
